import React, { Component } from "react";
import CryptoJS from "crypto-js";
import $ from "jquery";
import Select from "react-select/lib/Creatable";
import Switch from "@material-ui/core/Switch";
import "assets/scss/styles.css";
import CheckBox from "./CheckBox";
import DatePicker from "./DatePicker";
import BackButton from "./BackButton";
// import DateTimeField from "./DateTimeField";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import Nouislider from "react-nouislider";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import ShoneysDemo from "../CSegmentQueryBuilder/Shoneys";
import MortonsDemo from "../CSegmentQueryBuilder/Mortons";
import ChuckecheeseDemo from "../CSegmentQueryBuilder/Chuckecheese";
import PrimantiBrosDemo from "../CSegmentQueryBuilder/PrimantiBros";
import HoulihansDemo from "../CSegmentQueryBuilder/Houlihans";
import BarlouieDemo from "../CSegmentQueryBuilder/Barlouie";
import BaddaddysDemo from "../CSegmentQueryBuilder/Baddaddys";
import CafeDemo from "../CSegmentQueryBuilder/Cafe";
import Button from "components/CustomButtons/Button.jsx";
import isEqual from "lodash/isEqual";
import { connect } from "react-redux";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import TextField from "@material-ui/core/TextField";
import API from "@aws-amplify/api";

let apiName = process.env.REACT_APP_AMPLIFY_API;
let Demo = [];
let AcquisitionDemo = [];
let CombinedAudienceDemo = [];

// Created this for Reward Expiration Filter for Goodwill Client
let rewardExpirationGoodwill = {
  value: "reward_expiration",
  label: "Reward Expiration",
  type: "customizedNumber",
  data: [
    {
      value:
        "ca.cust_id IN (select cust_id from goodwill_refined.loyalty where loyalty_id IN(select customer_id from goodwill_source.tb_coupon where coupon_id NOT IN (select coupon_id from goodwill_source.tb_coupon_used) AND date(date_parse(act_date, '%c/%e/%Y %r')) <= current_date AND date(date_parse(deact_time, '%c/%e/%Y %r')) = date_add('day',{daysFromExpiration},current_date) AND orig_template_id = '{offerCode}'))",
      label: "Offer Code And Expiration",
      type: "customizedNumber",
      end: "true",
      data: [],
    },
  ],
};

// Code Block to fetch List Items for Filters:
// if (localStorage.getItem("logoName") != null) {
//   let selectionpath = "/selections";
//   let selectionparams = {
//     headers: {
//       cname: JSON.parse(
//         CryptoJS.AES.decrypt(
//           localStorage.getItem("logoName"),
//           process.env.REACT_APP_PASS
//         ).toString(CryptoJS.enc.Utf8)
//       ),
//     },
//   };
//   let listpath = "/lists";
//   let listparams = {
//     headers: {
//       clientId: JSON.parse(
//         CryptoJS.AES.decrypt(
//           localStorage.getItem("clientId"),
//           process.env.REACT_APP_PASS
//         ).toString(CryptoJS.enc.Utf8)
//       ),
//     },
//   };
//   API.get(apiName, selectionpath, selectionparams)
//     .then((response) => {
//       Demo = response[0]["selectionsjson"];
//       API.get(apiName, listpath, listparams)
//         .then((response) => {
//           let custLists = response.filter((x) => x.customerType == "Customer");
//           let tempdataArray = [];
//           for (let eachCL in custLists) {
//             let createdTimestamp = new Date(
//               custLists[eachCL]["createdAt"] * 1000
//             );
//             let stringCreatedAt =
//               createdTimestamp.getMonth() +
//               1 +
//               "/" +
//               createdTimestamp.getDate() +
//               "/" +
//               createdTimestamp.getFullYear();
//             let dataObj = {};
//             dataObj["value"] = custLists[eachCL]["id"];
//             // alert("The Data is: " + JSON.stringify(dataObj));
//             let listCount = "0";
//             if ("counts" in custLists[eachCL]) {
//               let chCountArr = custLists[eachCL]["counts"].filter(
//                 (x) => x.channelId == "0905c46e-6f48-4ed8-b2a9-35dbbf3bae91"
//               );
//               if (chCountArr.length == 0) {
//                 listCount = "0";
//               } else {
//                 listCount = chCountArr[0]["counts"][0]["customers"]["total"];
//               }
//             } else if ("emailCount" in custLists[eachCL]) {
//               listCount = custLists[eachCL]["emailCount"];
//             }
//             dataObj["label"] =
//               stringCreatedAt +
//               " - " +
//               custLists[eachCL]["title"] +
//               " - " +
//               listCount +
//               " Customers";
//             //custLists[eachCL]['nonemailCusts']
//             tempdataArray.push(dataObj);
//           }
//           let UpdateDemo = {
//             value: "List Membership",
//             label: "List Membership",
//             type: "select",
//             data: [
//               {
//                 value: "li.list_id",
//                 label: "Customers",
//                 type: "multiSelect",
//                 end: "true",
//                 data: tempdataArray,
//               },
//             ],
//           };
//           // Demo.push(UpdateDemo);
//           let goodwillClientId = JSON.parse(
//             CryptoJS.AES.decrypt(
//               localStorage.getItem("clientId"),
//               process.env.REACT_APP_PASS
//             ).toString(CryptoJS.enc.Utf8)
//           );
//           // alert("Client Id :  Before List Membership is :" + goodwillClientId);
//           if (goodwillClientId === "2bdbd6af-6cd3-4358-a1a0-437226a20ee9") {
//             console.log("Goodwill : Remove List Membership");
//           } else {
//             Demo.push(UpdateDemo);
//           }
//         })
//         .catch((error) => {
//           console.log(error);
//         });
//     })
//     .catch((error) => {
//        console.log(error);
//     });
// }

// Code Block to fetch List Items for Filters for V2 Clients and fetch Automations for Filters for V3 Clients:

if (localStorage.getItem("logoName") != null) {
  if (
    JSON.parse(
      CryptoJS.AES.decrypt(
        localStorage.getItem("model"),
        process.env.REACT_APP_PASS
      ).toString(CryptoJS.enc.Utf8)
    ) === "restaurant_v3"
  ) {
    if (localStorage.getItem("logoName") != null) {
      let selectionpath = "/selections";
      let selectionparams = {
        headers: {
          cname: JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("logoName"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ),
        },
      };
      API.get(apiName, selectionpath, selectionparams)
        .then((response) => {
          Demo = response[0]["selectionsjson"];
          localStorage.setItem(
            "CustomerSelections",
            CryptoJS.AES.encrypt(JSON.stringify(Demo), process.env.REACT_APP_PASS).toString()
          );
          AcquisitionDemo = response[0]["selectionsjsonacquisition"];
          localStorage.setItem(
            "AcquisitionSelections",
            CryptoJS.AES.encrypt(
              JSON.stringify(AcquisitionDemo),
              process.env.REACT_APP_PASS
            ).toString()
          );
          CombinedAudienceDemo = response[0]["selectionsjsoncombined"];
          localStorage.setItem(
            "CombinedSelections",
            CryptoJS.AES.encrypt(
              JSON.stringify(CombinedAudienceDemo),
              process.env.REACT_APP_PASS
            ).toString()
          );
          fetch(
            "https://73b404h189.execute-api.us-west-2.amazonaws.com/prod/automations",
            {
              method: "get",
              headers: {
                clientId: JSON.parse(
                  CryptoJS.AES.decrypt(
                    localStorage.getItem("clientId"),
                    process.env.REACT_APP_PASS
                  ).toString(CryptoJS.enc.Utf8)
                ),
              },
            }
          )
            .then((res) => res.json())
            .then((result) => {
              let custLists = result["Items"];
              let tempdataArray = [];
              for (let eachCL in custLists) {
                let createdTimestamp = new Date(
                  custLists[eachCL]["scheduledStart"] * 1000
                );
                let stringCreatedAt =
                  createdTimestamp.getMonth() +
                  1 +
                  "/" +
                  createdTimestamp.getDate() +
                  "/" +
                  createdTimestamp.getFullYear();
                let dataObj = {};
                dataObj["value"] = custLists[eachCL]["id"];

                // dataObj["label"] =
                //   custLists[eachCL]["name"] +
                //   " " +
                //   "Deployed Date - " +
                //   stringCreatedAt;

                dataObj["label"] =
                  "Start Date: " +
                  stringCreatedAt +
                  " - " +
                  custLists[eachCL]["name"];

                tempdataArray.push(dataObj);
              }
              let UpdateDemo = {
                value: "List Membership",
                label: "List Membership",
                type: "select",
                data: [
                  {
                    value: "li.list_id",
                    label: "Customers",
                    type: "multiSelect",
                    end: "true",
                    data: tempdataArray,
                  },
                ],
              };
              // Demo.push(UpdateDemo);
              let goodwillClientId = JSON.parse(
                CryptoJS.AES.decrypt(
                  localStorage.getItem("clientId"),
                  process.env.REACT_APP_PASS
                ).toString(CryptoJS.enc.Utf8)
              );
              if (goodwillClientId === "2bdbd6af-6cd3-4358-a1a0-437226a20ee9") {
                Demo.push(rewardExpirationGoodwill);
                localStorage.setItem(
                  "CustomerSelections",
                  CryptoJS.AES.encrypt(
                    JSON.stringify(Demo),
                    process.env.REACT_APP_PASS
                  ).toString()
                );
              } else {
                Demo.push(UpdateDemo);
                localStorage.setItem(
                  "CustomerSelections",
                  CryptoJS.AES.encrypt(
                    JSON.stringify(Demo),
                    process.env.REACT_APP_PASS
                  ).toString()
                );
              }
            });
        })
        .catch((error) => {
          console.log("Error Block ", error);
        });
    }
  } else {
    if (localStorage.getItem("logoName") != null) {
      let selectionpath = "/selections";
      let selectionparams = {
        headers: {
          cname: JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("logoName"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ),
        },
      };
      let listpath = "/lists";
      let listparams = {
        headers: {
          clientId: JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("clientId"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ),
        },
      };
      API.get(apiName, selectionpath, selectionparams)
        .then((response) => {
          Demo = response[0]["selectionsjson"];
          localStorage.setItem(
            "CustomerSelections",
            CryptoJS.AES.encrypt(JSON.stringify(Demo), process.env.REACT_APP_PASS).toString()
          );
          AcquisitionDemo = response[0]["selectionsjsonacquisition"];
          localStorage.setItem(
            "AcquisitionSelections",
            CryptoJS.AES.encrypt(
              JSON.stringify(AcquisitionDemo),
              process.env.REACT_APP_PASS
            ).toString()
          );
          CombinedAudienceDemo = response[0]["selectionsjsoncombined"];
          localStorage.setItem(
            "CombinedSelections",
            CryptoJS.AES.encrypt(
              JSON.stringify(CombinedAudienceDemo),
              process.env.REACT_APP_PASS
            ).toString()
          );
          API.get(apiName, listpath, listparams)
            .then((response) => {
              let custLists = response.filter(
                (x) => x.customerType == "Customer"
              );
              let tempdataArray = [];
              for (let eachCL in custLists) {
                let createdTimestamp = new Date(
                  custLists[eachCL]["createdAt"] * 1000
                );
                let stringCreatedAt =
                  createdTimestamp.getMonth() +
                  1 +
                  "/" +
                  createdTimestamp.getDate() +
                  "/" +
                  createdTimestamp.getFullYear();
                let dataObj = {};
                dataObj["value"] = custLists[eachCL]["id"];

                let listCount = "0";
                if ("counts" in custLists[eachCL]) {
                  let chCountArr = custLists[eachCL]["counts"].filter(
                    (x) => x.channelId == "0905c46e-6f48-4ed8-b2a9-35dbbf3bae91"
                  );
                  if (chCountArr.length == 0) {
                    listCount = "0";
                  } else {
                    listCount =
                      chCountArr[0]["counts"][0]["customers"]["total"];
                  }
                } else if ("emailCount" in custLists[eachCL]) {
                  listCount = custLists[eachCL]["emailCount"];
                }
                dataObj["label"] =
                  stringCreatedAt +
                  " - " +
                  custLists[eachCL]["title"] +
                  " - " +
                  listCount +
                  " Customers";
                //custLists[eachCL]['nonemailCusts']
                tempdataArray.push(dataObj);
              }
              let UpdateDemo = {
                value: "List Membership",
                label: "List Membership",
                type: "select",
                data: [
                  {
                    value: "li.list_id",
                    label: "Customers",
                    type: "multiSelect",
                    end: "true",
                    data: tempdataArray,
                  },
                ],
              };
              // Demo.push(UpdateDemo);
              let goodwillClientId = JSON.parse(
                CryptoJS.AES.decrypt(
                  localStorage.getItem("clientId"),
                  process.env.REACT_APP_PASS
                ).toString(CryptoJS.enc.Utf8)
              );
              if (goodwillClientId === "2bdbd6af-6cd3-4358-a1a0-437226a20ee9") {
                // console.log("Goodwill : Remove List Membership");
              } else {
                Demo.push(UpdateDemo);
                localStorage.setItem(
                  "CustomerSelections",
                  CryptoJS.AES.encrypt(
                    JSON.stringify(Demo),
                    process.env.REACT_APP_PASS
                  ).toString()
                );
              }
            })
            .catch((error) => {
              console.log("Error Block", error);
            });
        })
        .catch((error) => {
          console.log("Error Block", error);
        });
    }
  }
}

let selectedTempArr = Demo;
let optionsList = [];
let fetchDataOnSelect = Demo;
let isEnd = false;
let nextInputType = "select";
let isSqlOperatorSelected = false;
let sqlLabels = [];
let sqlValues = [];
let tempKeyValuePairSelectedArr = [];
let tempKeyValuePairResultArr = [];
let navLinks = "";
let showAddQueryButton = false;
let selectedResultQuery = [];
let selectedValueDataLabels = [];
let selectedValueDataValues = [];

const sqlData = [
  { value: "=", label: "is equal to (==)" },
  { value: "= ", label: "is equal to (==)" },
  { value: "!=", label: "is not equal to (!=)" },
  { value: "<", label: "is lesser than (<)" },
  { value: "<=", label: "is lesser than equal to (<=)" },
  { value: ">", label: "is greater than (>)" },
  { value: ">=", label: "is greater than equal to (>=)" },
  { value: "BETWEEN", label: "Between" },
  { value: "NOT BETWEEN", label: "Not in between" },
  { value: "IN", label: "any in" },
  { value: "NOT IN", label: "not in" },
  { value: "cardinality(array_intersect(", label: "includes any of" },
  { value: "cardinality(array_except(", label: "excludes any of" },
];

const sqlSelectionDict = {
  number: [
    { value: "=", label: "is equal to (==)" },
    { value: "!=", label: "is not equal to (!=)" },
    { value: "<", label: "is lesser than (<)" },
    { value: "<=", label: "is lesser than equal to (<=)" },
    { value: ">", label: "is greater than (>)" },
    { value: ">=", label: "is greater than equal to (>=)" },
    { value: "BETWEEN", label: "Between" },
    { value: "NOT BETWEEN", label: "Not in between" },
  ],
  string: [
    { value: "=", label: "is equal to (==)" },
    { value: "!=", label: "is not equal to (!=)" },
    //{ value: "<", label: "is lesser than (<)" },
    //{ value: "<=", label: "is lesser than equal to (<=)" },
    //{ value: ">", label: "is greater than (>)" },
    //{ value: ">=", label: "is greater than equal to (>=)" },
    //{ value: "BETWEEN", label: "Between" },
    //{ value: "NOT BETWEEN", label: "Not in between" }
  ],
  select: [{ value: "=", label: "is equal to (==)" }],
  select_nonString: [{ value: "= ", label: "is equal to (==)" }],
  multiSelect: [
    { value: "IN", label: "any in" },
    { value: "NOT IN", label: "not in" },
  ],
  multiSelect_agg: [
    { value: "cardinality(array_intersect(", label: "includes any of" },
    { value: "cardinality(array_except(", label: "excludes any of" },
  ],
  checkbox: [
    { value: "IN", label: "any in" },
    { value: "NOT IN", label: "not in" },
  ],
  radio: [{ value: "=", label: "is equal to (==)" }],
  sliders: [
    { value: "=", label: "is equal to (==)" },
    { value: "!=", label: "is not equal to (!=)" },
    { value: "<", label: "is lesser than (<)" },
    { value: "<=", label: "is lesser than equal to (<=)" },
    { value: ">", label: "is greater than (>)" },
    { value: ">=", label: "is greater than equal to (>=)" },
    // { value: "BETWEEN", label: "Between" },
    // { value: "NOT BETWEEN", label: "Not in between" }
  ],
  datePicker: [{ value: "=", label: "is equal to (==)" }],
  toggle: [{ value: "=", label: "is equal to (==)" }],
  customizedNumber: [{ value: "=", label: "is equal to (==)" }],
};

class Selections extends Component {
  constructor(props) {
    super(props);

    this.handleAcquistionChanges = this.handleAcquistionChanges.bind(this);
    this.prepareOptionsData = this.prepareOptionsData.bind(this);
    this.setPreviousValue = this.setPreviousValue.bind(this);
    this.setNextValue = this.setNextValue.bind(this);
    this.onBackButtonClick = this.onBackButtonClick.bind(this);
    this.handleRadioButtonChange = this.handleRadioButtonChange.bind(this);
    this.onAddBackButtonClick = this.onAddBackButtonClick.bind(this);
    this.clearSelections = this.clearSelections.bind(this);
  }
  state = {
    error: false,
    locationsInputError: false, // Added to validate the location input value
    localStorageClientId: "",
    inputLocationsText: "",
    inputLocationsArray: [],
    toggleFlag: false,
    dropdownOrTextFieldToggle: false,
    locationFlag: false,
    modelDecileFlag: false,
  };

  componentDidMount() {
    this.setState({
      localStorageClientId: JSON.parse(
        CryptoJS.AES.decrypt(
          localStorage.getItem("clientId"),
          process.env.REACT_APP_PASS
        ).toString(CryptoJS.enc.Utf8)
      ),
    });
  }

  componentWillMount() {
    if (
      this.props.mode === "Edit" &&
      this.props.selectedRule !== "" &&
      this.props.selectedIndex !== "no_index"
    ) {
      selectedResultQuery.push(
        this.props.cust_tillSqlSelectionArr[this.props.selectedIndex][
          this.props.selectedRule
        ]
      );
      for (let key in selectedResultQuery[0]) {
        selectedValueDataLabels.push(selectedResultQuery[0][key].label);
        selectedValueDataValues.push(selectedResultQuery[0][key].value);
      }
      this.setState({ selectedOption: selectedResultQuery[0][0] });
    }

    let selectedCustomerType = JSON.parse(
      CryptoJS.AES.decrypt(
        localStorage.getItem("selectedCustomerType"),
        process.env.REACT_APP_PASS
      ).toString(CryptoJS.enc.Utf8)
    );
    if (selectedCustomerType === "Customer") {
      Demo = JSON.parse(
        CryptoJS.AES.decrypt(
          localStorage.getItem("CustomerSelections"),
          process.env.REACT_APP_PASS
        ).toString(CryptoJS.enc.Utf8)
      );
    } else if (selectedCustomerType === "Acquistion") {
      Demo = JSON.parse(
        CryptoJS.AES.decrypt(
          localStorage.getItem("AcquisitionSelections"),
          process.env.REACT_APP_PASS
        ).toString(CryptoJS.enc.Utf8)
      );
    } else {
      Demo = JSON.parse(
        CryptoJS.AES.decrypt(
          localStorage.getItem("CombinedSelections"),
          process.env.REACT_APP_PASS
        ).toString(CryptoJS.enc.Utf8)
      );
    }

    fetchDataOnSelect = Demo;
    isEnd = false;
    nextInputType = "select";
    isSqlOperatorSelected = false;
    sqlLabels = [];
    sqlValues = [];
    tempKeyValuePairSelectedArr = [];
    showAddQueryButton = false;
    this.prepareOptionsData(Demo);
    for (let key in sqlData) {
      let data = sqlData[key];
      sqlValues.push(data.value);
      sqlLabels.push(data.label);
    }
  }

  state = {
    selectedOption: null,
    selectedValue: "select",
  };

  dateFormatter(sampleDate) {
    //FORMAT should be 2018-12-05
    let dictOfMonths = {
      "01": "JAN",
      "02": "FEB",
      "03": "MAR",
      "04": "APR",
      "05": "MAY",
      "06": "JUN",
      "07": "JUL",
      "08": "AUG",
      "09": "SEP",
      "10": "OCT",
      "11": "NOV",
      "12": "DEC",
    };
    let splitDate = sampleDate.split("-");
  }

  // ? Commented the below code for implementing the custom selections based on the requirements
  // async prepareOptionsData(data) {
  //   optionsList = [];
  //   if ($.isArray(data)) {
  //     data.map((options, key) => {
  //       if ("label" in options && "value" in options) {
  //         let optionData = {};
  //         optionData["label"] = options.label;
  //         optionData["value"] = options.value;
  //         optionsList.push(optionData);
  //       }
  //     });
  //   } else {
  //     optionsList = data;
  //   }
  // }

  async prepareOptionsData(data) {
    if (
      JSON.parse(
        CryptoJS.AES.decrypt(
          localStorage.getItem("activeChannel"),
          process.env.REACT_APP_PASS
        ).toString(CryptoJS.enc.Utf8)
      ) === "8905c46e-6f48-4ed8-b2a9-35dbbf3bae91" &&
      JSON.parse(
        CryptoJS.AES.decrypt(
          localStorage.getItem("clientId"),
          process.env.REACT_APP_PASS
        ).toString(CryptoJS.enc.Utf8)
      ) === "712cc8e9-3a79-4900-b122-ec9812e0f0ca"
    ) {
      optionsList = [];
      if ($.isArray(data)) {
        data.map((options, key) => {
          if ("label" in options && "value" in options) {
            let optionData = {};
            optionData["label"] = options.label;
            optionData["value"] = options.value;
            if (
              // options.label !== "Customer has Opted-out of Loyalty" &&
              options.value !== "lo.email_marketable"
            ) {
              optionsList.push(optionData);
            }
            // optionsList.push(optionData);
          }
        });
      } else {
        optionsList = data;
      }
    } else if (
      JSON.parse(
        CryptoJS.AES.decrypt(
          localStorage.getItem("activeChannel"),
          process.env.REACT_APP_PASS
        ).toString(CryptoJS.enc.Utf8)
      ) === "g786cb0f-eecc-4b87-adef-34eb20f3f766" &&
      JSON.parse(
        CryptoJS.AES.decrypt(
          localStorage.getItem("clientId"),
          process.env.REACT_APP_PASS
        ).toString(CryptoJS.enc.Utf8)
      ) === "712cc8e9-3a79-4900-b122-ec9812e0f0ca"
    ) {
      optionsList = [];
      if ($.isArray(data)) {
        data.map((options, key) => {
          if ("label" in options && "value" in options) {
            let optionData = {};
            optionData["label"] = options.label;
            optionData["value"] = options.value;
            if (
              // options.label !== "Customer has Opted-out of Loyalty" &&
              options.value !== "oc.email_marketable"
            ) {
              optionsList.push(optionData);
            }
            // optionsList.push(optionData);
          }
        });
      } else {
        optionsList = data;
      }
    } else if (
      (
        JSON.parse(
        CryptoJS.AES.decrypt(
          localStorage.getItem("activeChannel"),
          process.env.REACT_APP_PASS
        ).toString(CryptoJS.enc.Utf8)
      ) !== "d1606aea-0c0d-4fba-83e8-a124f414a953" &&
        JSON.parse(
          CryptoJS.AES.decrypt(
            localStorage.getItem("activeChannel"),
            process.env.REACT_APP_PASS
          ).toString(CryptoJS.enc.Utf8)
        ) !== "a8f39ffb-24c5-432a-9bcd-e5d0166a320e" &&
        JSON.parse(
          CryptoJS.AES.decrypt(
            localStorage.getItem("activeChannel"),
            process.env.REACT_APP_PASS
          ).toString(CryptoJS.enc.Utf8)
        ) !== "3c8a9cf7-a0b2-4845-8436-d598181e6d78"
      ) &&
      (JSON.parse(
        CryptoJS.AES.decrypt(
          localStorage.getItem("clientId"),
          process.env.REACT_APP_PASS
        ).toString(CryptoJS.enc.Utf8)
      ) === "8c001fde-3728-48dc-9950-b8480ca9fbee" ||
      JSON.parse(
        CryptoJS.AES.decrypt(
          localStorage.getItem("clientId"),
          process.env.REACT_APP_PASS
        ).toString(CryptoJS.enc.Utf8)
      ) === "7203dd51-f88b-4a4b-877c-92326d027915" ||
      JSON.parse(
        CryptoJS.AES.decrypt(
          localStorage.getItem("clientId"),
          process.env.REACT_APP_PASS
        ).toString(CryptoJS.enc.Utf8)
      ) === "f1fbce23-e2ef-463c-bc97-6cde3c4cc4ac" ||
      JSON.parse(
        CryptoJS.AES.decrypt(
          localStorage.getItem("clientId"),
          process.env.REACT_APP_PASS
        ).toString(CryptoJS.enc.Utf8)
      ) === "874b6c6a-83ff-480b-b615-1972538813ba" ||
      JSON.parse(
        CryptoJS.AES.decrypt(
          localStorage.getItem("clientId"),
          process.env.REACT_APP_PASS
        ).toString(CryptoJS.enc.Utf8)
      ) === "b76e7818-deb1-4526-93a7-b398df3ea357" ||
      JSON.parse(
        CryptoJS.AES.decrypt(
          localStorage.getItem("clientId"),
          process.env.REACT_APP_PASS
        ).toString(CryptoJS.enc.Utf8)
      ) === "e08840c5-c7d0-48c7-9c24-124b4cd80735" ||
      JSON.parse(
        CryptoJS.AES.decrypt(
          localStorage.getItem("clientId"),
          process.env.REACT_APP_PASS
        ).toString(CryptoJS.enc.Utf8)
      )  === "68a4d4cc-1e57-4ccf-9dd1-a5ae890d0f2e" ||
      JSON.parse(
        CryptoJS.AES.decrypt(
          localStorage.getItem("clientId"),
          process.env.REACT_APP_PASS
        ).toString(CryptoJS.enc.Utf8)
      )  === "0bc2a383-9ae0-4e9e-9652-0fb762ba6119" ||
      JSON.parse(
        CryptoJS.AES.decrypt(
          localStorage.getItem("clientId"),
          process.env.REACT_APP_PASS
        ).toString(CryptoJS.enc.Utf8)
      ) === "7bf99619-30a3-47a3-b1de-d72b4f7f99a7" ||
      JSON.parse(
        CryptoJS.AES.decrypt(
          localStorage.getItem("clientId"),
          process.env.REACT_APP_PASS
        ).toString(CryptoJS.enc.Utf8)
      ) === "a4dda78e-7678-4aaf-9bef-60a229085fc8" ||
      JSON.parse(
        CryptoJS.AES.decrypt(
          localStorage.getItem("clientId"),
          process.env.REACT_APP_PASS
        ).toString(CryptoJS.enc.Utf8)
      ) === "3fe7e557-16f5-406c-bbc8-887fdec7ba8b" ||
      JSON.parse(
        CryptoJS.AES.decrypt(
          localStorage.getItem("clientId"),
          process.env.REACT_APP_PASS
        ).toString(CryptoJS.enc.Utf8)
      ) === "d1522630-2b9d-424e-a399-7ab3f7be274f" ||
      JSON.parse(
        CryptoJS.AES.decrypt(
          localStorage.getItem("clientId"),
          process.env.REACT_APP_PASS
        ).toString(CryptoJS.enc.Utf8)
      ) === "cf6144d2-bb68-43b6-9876-dbf620b57c21" ||
      JSON.parse(
        CryptoJS.AES.decrypt(
          localStorage.getItem("clientId"),
          process.env.REACT_APP_PASS
        ).toString(CryptoJS.enc.Utf8)
      ) === "83da098f-2fc7-4b98-8455-c08f9aceb4ed" ||
      JSON.parse(
        CryptoJS.AES.decrypt(
          localStorage.getItem("clientId"),
          process.env.REACT_APP_PASS
        ).toString(CryptoJS.enc.Utf8)
      ) === "37f97bea-f005-4be1-8e41-286ad79a7f3a" ||
      JSON.parse(
        CryptoJS.AES.decrypt(
          localStorage.getItem("clientId"),
          process.env.REACT_APP_PASS
        ).toString(CryptoJS.enc.Utf8)
      ) === "ec5a162e-5e87-4819-93bd-70bbf3b5f096" ||
      JSON.parse(
        CryptoJS.AES.decrypt(
          localStorage.getItem("clientId"),
          process.env.REACT_APP_PASS
        ).toString(CryptoJS.enc.Utf8)
      ) === "24ab940a-50d2-41fd-b3b2-c67ca6cb0304" ) 
    ) {
      optionsList = [];
      if ($.isArray(data)) {
        data.map((options, key) => {
          if ("label" in options && "value" in options) {
            let optionData = {};
            optionData["label"] = options.label;
            optionData["value"] = options.value;
            if (options.label !== "Status" && options.value !== "Status") {
              optionsList.push(optionData);
            }
          }
        });
      } else {
        optionsList = data;
      }
    } else {
      // alert("other client");
      optionsList = [];
      if ($.isArray(data)) {
        data.map((options, key) => {
          if ("label" in options && "value" in options) {
            let optionData = {};
            optionData["label"] = options.label;
            optionData["value"] = options.value;
            optionsList.push(optionData);
            if (optionData["label"] === "Model Decile") {
              this.setState({ modelDecileFlag: true });
            }
          }
        });
      } else {
        optionsList = data;
      }
    }
  }

  async setNextValue(options, setVar = true) {
    if (setVar) {
      await this.setState({ selectedValue: nextInputType });
    }
    if ("type" in options) {
      nextInputType = options.type;
    }
  }

  async setPreviousValue(options, setVar = true) {
    if ("type" in options) {
      nextInputType = options.type;
    }
    if (setVar) {
      await this.setState({ selectedValue: nextInputType });
    }
  }

  async handleAcquistionChanges(selectedValueData) {
    if (Array.isArray(selectedValueData)) {
      selectedValueData.map((options, key) => {
        if ("label" in options && "value" in options) {
          localStorage.setItem(
            "automationSelectedId",
            CryptoJS.AES.encrypt(
              JSON.stringify(options.value),
              process.env.REACT_APP_PASS
            ).toString()
          );
        }
      });
    }

    // Added the below code for the locations copy paste feature

    if (selectedValueData["label"] === "Location") {
      this.setState({ locationflag: true });
    } else {
      // this.setState({ locationflag: false });
    }
    if (
      selectedValueData["label"] === "any in" ||
      selectedValueData["label"] === "not in" ||
      selectedValueData["label"] === "excludes any of" ||
      selectedValueData["label"] === "includes any of"
    ) {
      this.setState({ toggleFlag: true });
    } else {
      // this.setState({ toggleFlag: false });
    }
    //
    if (this.props.mode === "Edit") {
      let tempKeyValuePairSelectedArrLength =
        tempKeyValuePairSelectedArr.length;
      if (
        selectedResultQuery.length > 0 &&
        $.inArray(selectedValueData.label, sqlLabels) != -1 &&
        $.inArray(selectedValueData.value, sqlValues) != -1
      ) {
        tempKeyValuePairResultArr = [];
        if (
          nextInputType == "multiSelect" ||
          nextInputType == "multiSelect_agg"
        ) {
          if (
            this.props.cust_afterSqlSelectionArr.length > 0 &&
            this.props.cust_afterSqlSelectionArr[this.props.selectedIndex] !==
              undefined &&
            this.props.cust_afterSqlSelectionArr[this.props.selectedIndex][
              this.props.selectedRule
            ] !== undefined
          ) {
            tempKeyValuePairResultArr.push(
              this.props.cust_afterSqlSelectionArr[this.props.selectedIndex][
                this.props.selectedRule
              ]
            );
            this.setState(
              {
                selectedOption: this.props.cust_afterSqlSelectionArr[
                  this.props.selectedIndex
                ][this.props.selectedRule],
              },
              () => {
                let selectedLocationsAsText = "";
                for (let i = 0; i < this.state.selectedOption.length; i++) {
                  if (selectedLocationsAsText === "") {
                    selectedLocationsAsText =
                      selectedLocationsAsText +
                      this.state.selectedOption[i].value;
                  } else {
                    selectedLocationsAsText =
                      selectedLocationsAsText +
                      "," +
                      this.state.selectedOption[i].value;
                  }
                }
                this.state.inputLocationsText = selectedLocationsAsText;
              }
            );
          }
        } else {
          if (
            this.props.cust_afterSqlSelectionArr.length > 0 &&
            this.props.cust_afterSqlSelectionArr[this.props.selectedIndex] !==
              undefined &&
            this.props.cust_afterSqlSelectionArr[this.props.selectedIndex][
              this.props.selectedRule
            ] !== undefined
          ) {
            this.setState({
              selectedOption: this.props.cust_afterSqlSelectionArr[
                this.props.selectedIndex
              ][this.props.selectedRule][0],
            });
            tempKeyValuePairResultArr.push([
              this.props.cust_afterSqlSelectionArr[this.props.selectedIndex][
                this.props.selectedRule
              ][0],
            ]);
          }
        }
        selectedResultQuery = [];
      } else if (
        selectedResultQuery.length > 0 &&
        $.inArray(selectedValueData.label, selectedValueDataLabels) != -1 &&
        $.inArray(selectedValueData.value, selectedValueDataValues) != -1
      ) {
        this.setState({
          selectedOption:
            selectedResultQuery[0][tempKeyValuePairSelectedArrLength + 1],
        });
      } else {
        selectedResultQuery = [];
        this.setState({ selectedOption: "" });
      }
    }
    showAddQueryButton = false;
    let selectedDetails = {};
    if (!$.isArray(selectedValueData)) {
      let selectedResultValue = selectedValueData.value;
      let selectedResultLable = selectedValueData.label;
      selectedDetails["label"] = selectedResultLable;
      selectedDetails["value"] = selectedResultValue;
    }
    let arrayLength = tempKeyValuePairSelectedArr.length - 1;
    if (
      $.isEmptyObject(tempKeyValuePairSelectedArr) ||
      ($.inArray(tempKeyValuePairSelectedArr[arrayLength].label, sqlLabels) ==
        -1 &&
        $.inArray(tempKeyValuePairSelectedArr[arrayLength].value, sqlValues) ==
          -1)
    ) {
      if (this.props.mode !== "Edit" && this.state.selectedOption != "") {
        await this.setState({ selectedOption: "" });
      }
      await tempKeyValuePairSelectedArr.push(selectedDetails);
      let index = "";
      let tempArr = [];
      let selectedBackData = Demo;
      let isEnd = false;
      let arrCount = 0;
      if (tempKeyValuePairSelectedArr.length > 0) {
        if (
          $.inArray(
            tempKeyValuePairSelectedArr[tempKeyValuePairSelectedArr.length - 1]
              .label,
            sqlLabels
          ) > -1 &&
          $.inArray(
            tempKeyValuePairSelectedArr[tempKeyValuePairSelectedArr.length - 1]
              .value,
            sqlValues
          ) > -1
        ) {
          arrCount = tempKeyValuePairSelectedArr.length - 1;
        } else {
          arrCount = tempKeyValuePairSelectedArr.length;
        }
        for (let i = 0; i < arrCount; i++) {
          var equal = isEqual(selectedBackData, Demo); // true
          if (equal) {
            index = Demo.findIndex(
              (data) => data.value === tempKeyValuePairSelectedArr[i].value
            );
          } else {
            index = selectedBackData.findIndex(
              (data) => data.value === tempKeyValuePairSelectedArr[i].value
            );
          }
          if (
            selectedBackData[index].hasOwnProperty("end") &&
            selectedBackData[index].end == "true"
          ) {
            if (
              $.inArray(
                tempKeyValuePairSelectedArr[
                  tempKeyValuePairSelectedArr.length - 1
                ].label,
                sqlLabels
              ) > -1 &&
              $.inArray(
                tempKeyValuePairSelectedArr[
                  tempKeyValuePairSelectedArr.length - 1
                ].value,
                sqlValues
              ) > -1
            ) {
              tempArr = selectedBackData[index];
              selectedBackData = selectedBackData[index]["data"];
              showAddQueryButton = true;
            } else {
              isEnd = true;
              tempArr = selectedBackData[index];
              selectedBackData = sqlSelectionDict[tempArr.type];
            }
          } else {
            if ("data" in selectedBackData[index]) {
              tempArr = selectedBackData[index];
              selectedBackData = selectedBackData[index]["data"];
            } else {
              tempArr = selectedBackData[index];
              selectedBackData = selectedBackData[index];
            }
          }
        }
      }
      fetchDataOnSelect = selectedBackData;
      await this.prepareOptionsData(selectedBackData);
      if (!isEnd) {
        await this.setNextValue(tempArr);
      } else {
        await this.setNextValue(tempArr, false);
        this.setState({ selectedValue: "select" });
      }
    } else {
      showAddQueryButton = true;
      tempKeyValuePairResultArr = [];
      if ($.isArray(selectedValueData)) {
        tempKeyValuePairResultArr.push(selectedValueData);
      } else {
        tempKeyValuePairResultArr.push([selectedValueData]);
      }
      this.setState({ selectedOption: selectedValueData });
    }
  }

  async onBackButtonClick() {
    showAddQueryButton = false;
    let label =
      tempKeyValuePairSelectedArr[tempKeyValuePairSelectedArr.length - 1].label;
    let value =
      tempKeyValuePairSelectedArr[tempKeyValuePairSelectedArr.length - 1].value;
    let arr = {};
    arr["label"] = label;
    arr["value"] = value;
    await this.setState({ selectedOption: arr });
    let index = "";
    let tempArr = [];
    let selectedBackData = Demo;
    if (tempKeyValuePairSelectedArr.length - 1 > 0) {
      if (
        $.inArray(
          tempKeyValuePairSelectedArr[tempKeyValuePairSelectedArr.length - 1]
            .label,
          sqlLabels
        ) > -1 &&
        $.inArray(
          tempKeyValuePairSelectedArr[tempKeyValuePairSelectedArr.length - 1]
            .value,
          sqlValues
        ) > -1
      ) {
        selectedBackData = sqlSelectionDict[nextInputType];
        tempKeyValuePairResultArr = [];
        tempKeyValuePairSelectedArr.pop();
        await this.prepareOptionsData(selectedBackData);
        this.setState({ selectedValue: "select" });
        return false;
      } else {
        for (let i = 0; i < tempKeyValuePairSelectedArr.length - 1; i++) {
          var equal = isEqual(selectedBackData, Demo); // true
          if (equal) {
            index = Demo.findIndex(
              (data) => data.value === tempKeyValuePairSelectedArr[i].value
            );
          } else {
            index = selectedBackData.findIndex(
              (data) => data.value === tempKeyValuePairSelectedArr[i].value
            );
          }
          if ("data" in selectedBackData[index]) {
            tempArr = selectedBackData[index];
            selectedBackData = selectedBackData[index]["data"];
          } else {
            tempArr = selectedBackData[index];
            selectedBackData = selectedBackData[index];
          }
          if (i + 1 === tempKeyValuePairSelectedArr.length - 1) {
            tempKeyValuePairSelectedArr.pop();
          }
        }
      }
    } else {
      tempArr = Demo;
      selectedBackData = tempArr;
      tempKeyValuePairSelectedArr.pop();
    }
    fetchDataOnSelect = selectedBackData;
    await this.prepareOptionsData(selectedBackData);
    await this.setPreviousValue(tempArr);
  }

  async handleRadioButtonChange(event) {
    tempKeyValuePairResultArr.pop();
    let selectedDetails = {};
    let selectedResultValue = event.target.value;

    selectedResultValue =
      selectedResultValue == "true"
        ? true
        : selectedResultValue == "false"
          ? false
          : selectedResultValue;

    let selectedResultLable = "";
    let selectedResultValue1 = 0;
    optionsList.map((options, key) => {
      if (options.value == selectedResultValue) {
        selectedResultLable = options.label;
        selectedResultValue1 = options.value;
      }
    });
    selectedDetails["label"] = selectedResultLable;
    selectedDetails["value"] = selectedResultValue1;
    // if (this.props.mode === "Edit") {
    //   tempKeyValuePairResultArr.push([[selectedDetails]]);
    // } else {
    //   tempKeyValuePairResultArr.push([selectedDetails]);
    // }
    tempKeyValuePairResultArr.push([selectedDetails]);
    await this.setState({ selectedOption: selectedDetails });
  }

  onSubmitButtonClick = () => {
    tempKeyValuePairResultArr = [];
    if (
      this.state.inputLocationsText !== undefined &&
      this.state.inputLocationsText.trim() !== ""
    ) {
      let enteredValues = this.state.inputLocationsText
        .split(",")
        .map(function(item) {
          if (item.includes('"')) {
            item = item.replaceAll('"', "");
          }
          if (item.includes("'")) {
            item = item.replaceAll("'", "");
          }
          return item.trim();
        });

      let enteredUniqueValues = [...new Set(enteredValues)];

      this.setState(
        {
          inputLocationsArray: enteredUniqueValues,
        },
        () => {
          let val = [];
          for (let i = 0; i < optionsList.length; i++) {
            for (let j = 0; j < this.state.inputLocationsArray.length; j++) {
              if (optionsList[i].value === this.state.inputLocationsArray[j]) {
                val.push(optionsList[i]);
              }
            }
          }
          tempKeyValuePairResultArr.push(val);
          this.onAddBackButtonClick();
        }
      );
    } else {
      this.setState({ locationsInputError: true });
      setTimeout(
        function() {
          this.setState({
            locationsInputError: false,
          });
        }.bind(this),
        3000
      );
    }
  };

  inputLocationsOnChange = (event) => {
    this.setState({
      inputLocationsText: event.target.value,
    });
  };

  toggleDropDownOrText(e) {
    this.setState({ dropdownOrTextFieldToggle: e });
  }

  async onAddBackButtonClick() {
    if (tempKeyValuePairResultArr.length > 0) {
      await this.props.dispatch({
        type: "CUST_TILL_SQL_PUSH",
        payload: tempKeyValuePairSelectedArr,
        selectedIndex: this.props.selectedIndex,
        selectedRule: this.props.selectedRule,
      });
      await this.props.dispatch({
        type: "CUST_AFTER_SQL_PUSH",
        payload: tempKeyValuePairResultArr,
        selectedIndex: this.props.selectedIndex,
        selectedRule: this.props.selectedRule,
      });
      this.props.dispatch({ type: "CUST_CLOSE_MODEL", payload: "close" });
      this.props.dispatch({ type: "CUST_Add" });
      await this.clearSelections();
      await this.prepareOptionsData(Demo);
      await this.setState({ selectedOption: "", selectedValue: "select" });
    } else {
      // alert("please select atleast one item");
      this.setState({ error: true });
    }
  }

  handleClose = () => {
    this.props.dispatch({ type: "CUST_CLOSE_MODEL", payload: "close" });
    // var x = [];
    // x["classicModal"] = false;
    // this.setState(x);
  };

  async clearSelections() {
    selectedTempArr = Demo;
    optionsList = [];
    fetchDataOnSelect = Demo;
    isEnd = false;
    nextInputType = "select";
    isSqlOperatorSelected = false;
    sqlLabels = [];
    sqlValues = [];
    tempKeyValuePairSelectedArr = [];
    tempKeyValuePairResultArr = [];
    navLinks = "";
    showAddQueryButton = false;
    for (let key in sqlData) {
      let data = sqlData[key];
      sqlValues.push(data.value);
      sqlLabels.push(data.label);
    }
  }

  prepareNavLinks() {
    navLinks = "";
    for (let nav in tempKeyValuePairSelectedArr) {
      if (tempKeyValuePairSelectedArr.length - 1 == nav) {
        navLinks = navLinks + tempKeyValuePairSelectedArr[nav].label;
      } else {
        navLinks = navLinks + tempKeyValuePairSelectedArr[nav].label + " > ";
      }
    }
  }

  async numberFieldMethod(event) {
    tempKeyValuePairResultArr.pop();
    let selectedDetails = {};
    let selectedResultValue = Number(event.target.value);
    let selectedResultLable = event.target.name;
    selectedDetails["label"] = selectedResultLable;
    selectedDetails["value"] = selectedResultValue;
    tempKeyValuePairResultArr.push([selectedDetails]);
    await this.setState({ selectedOption: selectedDetails });
  }

  async stringFieldMethod(event) {
    tempKeyValuePairResultArr.pop();
    let selectedDetails = {};
    let selectedResultValue = String(event.target.value);
    let selectedResultLable = event.target.name;
    selectedDetails["label"] = selectedResultLable;
    selectedDetails["value"] = selectedResultValue;
    tempKeyValuePairResultArr.push([selectedDetails]);
    await this.setState({ selectedOption: selectedDetails });
  }

  async rangenumberFieldMethod(event) {
    tempKeyValuePairResultArr.pop();
    let selectedDetails = {};
    let selectedResultValue = Number(event.target.value);
    let selectedResultLable = event.target.name;
    selectedDetails["label"] = "number_field_name";
    if (event.target.name == "number_field_name") {
      let selectedOpt = this.state.selectedOption;
      if (selectedOpt !== "" && selectedOpt["value"].indexOf("AND") !== -1) {
        let splitData = selectedOpt["value"].split(" AND ");
        selectedDetails["value"] = selectedResultValue + " AND " + splitData[1];
        selectedDetails["value"] = selectedDetails["value"].replace(/'/g, "");
      } else {
        selectedDetails["value"] = selectedResultValue + " AND " + "0";
        selectedDetails["value"] = selectedDetails["value"].replace(/'/g, "");
      }
      tempKeyValuePairResultArr.push([selectedDetails]);
      await this.setState({ selectedOption: selectedDetails });
    } else {
      let selectedOpt = this.state.selectedOption;
      if (selectedOpt !== "" && selectedOpt["value"].indexOf("AND") !== -1) {
        let splitData = selectedOpt["value"].split(" AND ");
        selectedDetails["value"] = splitData[0] + " AND " + selectedResultValue;
        selectedDetails["value"] = selectedDetails["value"].replace(/'/g, "");
      } else {
        selectedDetails["value"] = "0" + " AND " + selectedResultValue;
        selectedDetails["value"] = selectedDetails["value"].replace(/'/g, "");
      }
      tempKeyValuePairResultArr.push([selectedDetails]);
      await this.setState({ selectedOption: selectedDetails });
    }
  }

  // Goodwill Reward Expiration Filter
  async rangenumberFieldMethodOfferCode(event, type) {
    // if (type === "offerCode") {
    //   localStorage.setItem(
    //     "offerCodeInputValue",
    //     CryptoJS.AES.encrypt(
    //       JSON.stringify(event.target.value),
    //       process.env.REACT_APP_PASS
    //     ).toString()
    //   );
    // }
    // if (type === "offerCodeDuration") {
    //   localStorage.setItem(
    //     "offerCodeDurationInputValue",
    //     CryptoJS.AES.encrypt(
    //       JSON.stringify(event.target.value),
    //       process.env.REACT_APP_PASS
    //     ).toString()
    //   );
    // }
    tempKeyValuePairResultArr.pop();
    let selectedDetails = {};
    let selectedResultValue = Number(event.target.value);
    let selectedResultLable = event.target.name;
    selectedDetails["label"] = "number_field_name";
    if (event.target.name == "number_field_name") {
      let selectedOpt = this.state.selectedOption;
      if (selectedOpt !== "" && selectedOpt["value"].indexOf("AND") !== -1) {
        let splitData = selectedOpt["value"].split(" AND ");
        selectedDetails["value"] = selectedResultValue + " AND " + splitData[1];
        selectedDetails["value"] = selectedDetails["value"].replace(/'/g, "");
      } else {
        selectedDetails["value"] = selectedResultValue + " AND " + "0";
        selectedDetails["value"] = selectedDetails["value"].replace(/'/g, "");
      }
      tempKeyValuePairResultArr.push([selectedDetails]);
      await this.setState({ selectedOption: selectedDetails });
    } else {
      let selectedOpt = this.state.selectedOption;
      if (selectedOpt !== "" && selectedOpt["value"].indexOf("AND") !== -1) {
        let splitData = selectedOpt["value"].split(" AND ");
        selectedDetails["value"] = splitData[0] + " AND " + selectedResultValue;
        selectedDetails["value"] = selectedDetails["value"].replace(/'/g, "");
      } else {
        selectedDetails["value"] = "0" + " AND " + selectedResultValue;
        selectedDetails["value"] = selectedDetails["value"].replace(/'/g, "");
      }
      tempKeyValuePairResultArr.push([selectedDetails]);
      await this.setState({ selectedOption: selectedDetails });
    }
  }
  // Goodwill Reward Expiration Filter

  render() {
    const { classes } = this.props;
    const { selectedOption, selectedValue } = this.state;
    let htmlContent = "";
    let showButton = "";
    if (tempKeyValuePairSelectedArr.length > 0) {
      showButton = (
        // <div className="gobackinfo">
        <a
          href="javascript:void(0)"
          onClick={() => this.onBackButtonClick()}
          // className="btn btngoback"
          style={{ color: "black", padding: "15px", marginRight: "10px" }}
        >
          {"<"}
          Go Back
        </a>
      );
    }
    {
      this.prepareNavLinks();
    }
    if (
      selectedValue === "select" ||
      selectedValue === "select_nonString" ||
      selectedValue == "multiSelect" ||
      nextInputType == "multiSelect_agg"
    ) {
      htmlContent = (
        <div>
          <div
            id="classic-modal-slide-title"
            disableTypography
            // className="gobackinfo"
            // className={classes.modalHeader}
            style={{
              backgroundColor: "#d8d8d8",
              borderBottom: "none",
              padding: "10px",
              marginBottom: "10px",
              // paddingLeft: "24px"
              // minHeight: "16.43px"
            }}
          >
            <p
              style={{
                color: "#d8d8d8",
                margin: "0",
                paddingLeft: "0px",
                // lineHeight: "1.42857143"
              }}
            >
              <GridContainer>
                <GridItem xs={3}>{showButton}</GridItem>
                <GridItem xs={9}>
                  <span style={{ color: "black" }}>
                    <strong>Filter:</strong> &nbsp;
                    {navLinks}
                  </span>
                </GridItem>
              </GridContainer>
            </p>
          </div>

          {(this.state.localStorageClientId ===
            "712cc8e9-3a79-4900-b122-ec9812e0f0ca" ||
            this.state.localStorageClientId ===
              "8c001fde-3728-48dc-9950-b8480ca9fbee" ||
            this.state.localStorageClientId ===
              "3fe7e557-16f5-406c-bbc8-887fdec7ba8b" ||
            this.state.localStorageClientId ===
              "dc0df8ce-c87e-4746-a00e-d2c9ee4d7534" ||
            this.state.localStorageClientId ===
              "d1522630-2b9d-424e-a399-7ab3f7be274f" ||
            this.state.localStorageClientId ===
              "7203dd51-f88b-4a4b-877c-92326d027915" ||
            this.state.localStorageClientId ===
              "f1fbce23-e2ef-463c-bc97-6cde3c4cc4ac" ||
            this.state.localStorageClientId ===
              "874b6c6a-83ff-480b-b615-1972538813ba" ||
            this.state.localStorageClientId === 
              "b76e7818-deb1-4526-93a7-b398df3ea357" ||
            this.state.localStorageClientId ===
              "e08840c5-c7d0-48c7-9c24-124b4cd80735" || 
            this.state.localStorageClientId === 
              "68a4d4cc-1e57-4ccf-9dd1-a5ae890d0f2e" ||
            this.state.localStorageClientId ===
              "0bc2a383-9ae0-4e9e-9652-0fb762ba6119" ||  
            this.state.localStorageClientId ===
              "7bf99619-30a3-47a3-b1de-d72b4f7f99a7" ||
            this.state.localStorageClientId === 
              "a4dda78e-7678-4aaf-9bef-60a229085fc8" ||
            this.state.localStorageClientId === 
              "cf6144d2-bb68-43b6-9876-dbf620b57c21" ||
            this.state.localStorageClientId === 
              "83da098f-2fc7-4b98-8455-c08f9aceb4ed" ||
            this.state.localStorageClientId ===
              "37f97bea-f005-4be1-8e41-286ad79a7f3a" ||
            this.state.localStorageClientId ===
              "ec5a162e-5e87-4819-93bd-70bbf3b5f096" ||
            this.state.localStorageClientId ===
              "24ab940a-50d2-41fd-b3b2-c67ca6cb0304" ) &&
          this.state.toggleFlag &&
          this.state.locationflag ? (
            <FormControlLabel
              style={{
                paddingTop: "24px",
                paddingRight: "24px",
                paddingLeft: "24px",
                position: "relative",
                // display: "none", // TODO : Remove this after ColdStoneCreamert DIS-ACQ
              }}
              control={
                <Switch
                  color="primary"
                  checked={this.state.dropdownOrTextFieldToggle}
                  onChange={(event) =>
                    this.toggleDropDownOrText(event.target.checked)
                  }
                />
              }
              label={
                this.state.dropdownOrTextFieldToggle === true
                  ? "Select the locations"
                  : "Enter the locations"
              }
            />
          ) : (
            ""
          )}

          {(this.state.localStorageClientId ===
            "712cc8e9-3a79-4900-b122-ec9812e0f0ca" ||
            this.state.localStorageClientId ===
              "8c001fde-3728-48dc-9950-b8480ca9fbee" ||
            this.state.localStorageClientId ===
              "3fe7e557-16f5-406c-bbc8-887fdec7ba8b" ||
            this.state.localStorageClientId ===
              "dc0df8ce-c87e-4746-a00e-d2c9ee4d7534" ||
            this.state.localStorageClientId ===
              "d1522630-2b9d-424e-a399-7ab3f7be274f" ||
            this.state.localStorageClientId ===
              "7203dd51-f88b-4a4b-877c-92326d027915" ||
            this.state.localStorageClientId ===
              "f1fbce23-e2ef-463c-bc97-6cde3c4cc4ac" ||
            this.state.localStorageClientId ===
              "874b6c6a-83ff-480b-b615-1972538813ba" ||
            this.state.localStorageClientId === 
              "b76e7818-deb1-4526-93a7-b398df3ea357" ||
            this.state.localStorageClientId ===
              "e08840c5-c7d0-48c7-9c24-124b4cd80735" ||
            this.state.localStorageClientId === 
              "68a4d4cc-1e57-4ccf-9dd1-a5ae890d0f2e" ||
            this.state.localStorageClientId ===
              "0bc2a383-9ae0-4e9e-9652-0fb762ba6119" ||
            this.state.localStorageClientId ===
              "7bf99619-30a3-47a3-b1de-d72b4f7f99a7" ||
            this.state.localStorageClientId === 
              "a4dda78e-7678-4aaf-9bef-60a229085fc8" ||
            this.state.localStorageClientId === 
              "cf6144d2-bb68-43b6-9876-dbf620b57c21" ||
            this.state.localStorageClientId === 
              "83da098f-2fc7-4b98-8455-c08f9aceb4ed" ||
            this.state.localStorageClientId ===
              "37f97bea-f005-4be1-8e41-286ad79a7f3a" ||
            this.state.localStorageClientId ===
              "ec5a162e-5e87-4819-93bd-70bbf3b5f096" ||
            this.state.localStorageClientId ===
              "24ab940a-50d2-41fd-b3b2-c67ca6cb0304" ) &&
          this.state.dropdownOrTextFieldToggle ? (
            <React.Fragment>
              <TextField
                style={{
                  width: "100%",
                  paddingRight: "24px",
                  paddingLeft: "24px",
                  position: "relative",
                }}
                placeholder="Please enter the locations"
                value={this.state.inputLocationsText}
                onChange={(event) => this.inputLocationsOnChange(event)}
                type="text"
                name="number_field_name_range"
                inputProps={{
                  // min: 0,
                  // max: options.label,
                  shrink: true,
                  // key: key,
                }}
                margin="normal"
              />
              <span
                style={{
                  width: "100%",
                  paddingRight: "24px",
                  paddingBottom: "16px",
                  paddingLeft: "24px",
                  position: "relative",
                  color: "#0c3c54",
                  fontSize: "12px",
                }}
              >
                Enter the values in the comma separated form (example:
                100,101,102)
              </span>
            </React.Fragment>
          ) : (
            <DialogContent
              id="classic-modal-slide-description"
              style={{
                paddingTop: "24px",
                paddingRight: "24px",
                paddingBottom: "16px",
                paddingLeft: "24px",
                position: "relative",
                overflow: "visible",
              }}
            >
              {JSON.parse(
                CryptoJS.AES.decrypt(
                  localStorage.getItem("clientId"),
                  process.env.REACT_APP_PASS
                ).toString(CryptoJS.enc.Utf8)
              ) === "2bdbd6af-6cd3-4358-a1a0-437226a20ee9" ||
              JSON.parse(
                CryptoJS.AES.decrypt(
                  localStorage.getItem("clientId"),
                  process.env.REACT_APP_PASS
                ).toString(CryptoJS.enc.Utf8)
              ) === "712cc8e9-3a79-4900-b122-ec9812e0f0ca" ? (
                <Select
                  value={selectedOption}
                  onChange={this.handleAcquistionChanges}
                  // options={optionsList.sort(
                  //   (a, b) => (a.label > b.label ? 1 : -1)
                  // )}
                  options={optionsList}
                  style={{ width: "100%" }}
                  isMulti={
                    selectedValue == "multiSelect"
                      ? true
                      : selectedValue == "multiSelect_agg"
                        ? true
                        : false
                  }
                />
              ) : (
                <Select
                  value={selectedOption}
                  onChange={this.handleAcquistionChanges}
                  // options={optionsList.sort(
                  //   (a, b) => (a.label > b.label ? 1 : -1)
                  // )}
                  options={
                    JSON.parse(
                      CryptoJS.AES.decrypt(
                        localStorage.getItem("selectedCustomerType"),
                        process.env.REACT_APP_PASS
                      ).toString(CryptoJS.enc.Utf8)
                    ) === "Acquistion" && this.state.modelDecileFlag === true
                      ? optionsList
                      : optionsList.sort((a, b) => (a.label > b.label ? 1 : -1))
                  }
                  style={{ width: "100%" }}
                  isMulti={
                    selectedValue == "multiSelect"
                      ? true
                      : selectedValue == "multiSelect_agg"
                        ? true
                        : false
                  }
                />
              )}
            </DialogContent>
          )}

          {/* // Commented the below code to add the locations copy paste feature for Friday's client. */}
          {/* <DialogContent
            id="classic-modal-slide-description"
            style={{
              paddingTop: "24px",
              paddingRight: "24px",
              paddingBottom: "16px",
              paddingLeft: "24px",
              position: "relative",
              overflow: "visible",
            }}
          >
            {JSON.parse(
              CryptoJS.AES.decrypt(
                localStorage.getItem("clientId"),
                process.env.REACT_APP_PASS
              ).toString(CryptoJS.enc.Utf8)
            ) === "2bdbd6af-6cd3-4358-a1a0-437226a20ee9" ||
            JSON.parse(
              CryptoJS.AES.decrypt(
                localStorage.getItem("clientId"),
                process.env.REACT_APP_PASS
              ).toString(CryptoJS.enc.Utf8)
            ) === "712cc8e9-3a79-4900-b122-ec9812e0f0ca" ? (
              <Select
                value={selectedOption}
                onChange={this.handleAcquistionChanges}
                // options={optionsList.sort(
                //   (a, b) => (a.label > b.label ? 1 : -1)
                // )}
                options={optionsList}
                style={{ width: "100%" }}
                isMulti={
                  selectedValue == "multiSelect"
                    ? true
                    : selectedValue == "multiSelect_agg"
                      ? true
                      : false
                }
              />
            ) : (
              <Select
                value={selectedOption}
                onChange={this.handleAcquistionChanges}
                options={optionsList.sort(
                  (a, b) => (a.label > b.label ? 1 : -1)
                )}
                style={{ width: "100%" }}
                isMulti={
                  selectedValue == "multiSelect"
                    ? true
                    : selectedValue == "multiSelect_agg"
                      ? true
                      : false
                }
              />
            )}
          </DialogContent> */}
        </div>
      );
    } else if (selectedValue === "string") {
      let selectedStringValue = "";
      if (selectedOption.hasOwnProperty("value")) {
        selectedStringValue = selectedOption.value;
      }
      htmlContent = (
        <div>
          <DialogTitle
            id="classic-modal-slide-title"
            disableTypography
            style={{
              backgroundColor: "#d8d8d8",
              borderBottom: "none",
              padding: "10px",
              marginBottom: "10px",
            }}
          >
            <p
              style={{
                color: "#d8d8d8",
                margin: "0",
                paddingLeft: "0px",
              }}
            >
              <GridContainer>
                <GridItem xs={3}>{showButton}</GridItem>
                <GridItem xs={9}>
                  <span style={{ color: "black" }}>
                    <strong>Filter:</strong> &nbsp;
                    {navLinks}
                  </span>
                </GridItem>
              </GridContainer>
            </p>
          </DialogTitle>
          {optionsList.map((options, key) => (
            <div style={{ paddingRight: "25%", paddingLeft: "25%" }}>
              <TextField
                style={{
                  width: "100%",
                  marginTop: "2%",
                }}
                label="Please enter your input"
                value={selectedStringValue}
                onChange={(event) => this.stringFieldMethod(event)}
                type="text"
                name="string_field_name"
                inputProps={{
                  min: options.value,
                  max: options.label,
                  shrink: true,
                  key: key,
                }}
                margin="normal"
              />
            </div>
          ))}
        </div>
      );
    } else if (selectedValue === "number") {
      let selectedNumberValue = "";
      let selectedNumberValue1 = "";
      let selectedNumberValue2 = "";
      if (
        (tempKeyValuePairSelectedArr[tempKeyValuePairSelectedArr.length - 1]
          .label == "Between" &&
          tempKeyValuePairSelectedArr[tempKeyValuePairSelectedArr.length - 1]
            .value === "BETWEEN") ||
        (tempKeyValuePairSelectedArr[tempKeyValuePairSelectedArr.length - 1]
          .label == "Not in between" &&
          tempKeyValuePairSelectedArr[tempKeyValuePairSelectedArr.length - 1]
            .value === "NOT BETWEEN")
      ) {
        if (selectedOption.hasOwnProperty("value")) {
          let selVal = String(selectedOption.value);
          if (selVal.indexOf("AND") !== -1) {
            selVal = selectedOption.value.split(" AND ");
            selectedNumberValue1 = selVal[0];
            selectedNumberValue2 = selVal[1];
          }
        }
        htmlContent = (
          <div>
            <DialogTitle
              id="classic-modal-slide-title"
              disableTypography
              style={{
                backgroundColor: "#d8d8d8",
                borderBottom: "none",
                padding: "10px",
                marginBottom: "10px",
              }}
            >
              <p
                style={{
                  color: "#d8d8d8",
                  margin: "0",
                  paddingLeft: "0px",
                }}
              >
                <GridContainer>
                  <GridItem xs={3}>{showButton}</GridItem>
                  <GridItem xs={9}>
                    <span style={{ color: "black" }}>
                      <strong>Filter:</strong> &nbsp;
                      {navLinks}
                    </span>
                  </GridItem>
                </GridContainer>
              </p>
            </DialogTitle>
            {optionsList.map((options, key) => (
              <React.Fragment>
                <TextField
                  style={{
                    width: "48%",
                    marginTop: "2%",
                  }}
                  label="Please enter your input"
                  // value={selectedNumberValue1}
                  // Commented the above line and added the below line in order to allow 0 to be deleted.
                  value={selectedNumberValue1 > "0" ? selectedNumberValue1 : ""}
                  onChange={(event) => this.rangenumberFieldMethod(event)}
                  type="number"
                  name="number_field_name"
                  inputProps={{
                    min: options.value,
                    max: options.label,
                    shrink: true,
                    key: key,
                  }}
                  margin="normal"
                />
                <TextField
                  style={{
                    width: "48%",
                    marginTop: "2%",
                    paddingLeft: "2%",
                  }}
                  label="Please enter your input"
                  // value={selectedNumberValue2}
                  // Commented the above line and added the below line in order to allow 0 to be deleted.
                  value={selectedNumberValue2 > "0" ? selectedNumberValue2 : ""}
                  onChange={(event) => this.rangenumberFieldMethod(event)}
                  type="number"
                  name="number_field_name_range"
                  inputProps={{
                    min: options.value,
                    max: options.label,
                    shrink: true,
                    key: key,
                  }}
                  margin="normal"
                />
              </React.Fragment>
            ))}
          </div>
        );
      } else {
        if (selectedOption.hasOwnProperty("value")) {
          selectedNumberValue = selectedOption.value;
        }
        htmlContent = (
          <div>
            <DialogTitle
              id="classic-modal-slide-title"
              disableTypography
              style={{
                backgroundColor: "#d8d8d8",
                borderBottom: "none",
                padding: "10px",
                marginBottom: "10px",
              }}
            >
              <p
                style={{
                  color: "#d8d8d8",
                  margin: "0",
                  paddingLeft: "0px",
                }}
              >
                <GridContainer>
                  <GridItem xs={3}>{showButton}</GridItem>
                  <GridItem xs={9}>
                    <span style={{ color: "black" }}>
                      <strong>Filter:</strong> &nbsp;
                      {navLinks}
                    </span>
                  </GridItem>
                </GridContainer>
              </p>
            </DialogTitle>
            {optionsList.map((options, key) => (
              <div style={{ paddingRight: "25%", paddingLeft: "25%" }}>
                <TextField
                  style={{
                    width: "100%",
                    marginTop: "2%",
                  }}
                  label="Please enter your input"
                  // value={selectedNumberValue}
                  // Commented the above line and added the below line in order to allow 0 to be deleted.
                  value={selectedNumberValue > 0 ? selectedNumberValue : ""}
                  onChange={(event) => this.numberFieldMethod(event)}
                  type="number"
                  name="number_field_name"
                  inputProps={{
                    min: options.value,
                    max: options.label,
                    shrink: true,
                    key: key,
                  }}
                  margin="normal"
                />
              </div>
            ))}
          </div>
        );
      }
    } else if (selectedValue === "checkbox") {
      htmlContent = (
        <div
        // style={{
        //   paddingLeft: "20px",
        //   paddingTop: "30px",
        //   paddingRight: "20px"
        // }}
        >
          <DialogTitle
            id="classic-modal-slide-title"
            disableTypography
            // className={classes.modalHeader}
            style={{
              backgroundColor: "#d8d8d8",
              borderBottom: "none",
              padding: "10px",
              marginBottom: "10px",
              // paddingLeft: "24px"
              // minHeight: "16.43px"
            }}
          >
            <p
              style={{
                color: "#d8d8d8",
                margin: "0",
                paddingLeft: "0px",
                // lineHeight: "1.42857143"
              }}
            >
              <GridContainer>
                <GridItem xs={3}>{showButton}</GridItem>
                <GridItem xs={9}>
                  <span style={{ color: "black" }}>
                    <strong>Filter:</strong> &nbsp;
                    {navLinks}
                  </span>
                </GridItem>
              </GridContainer>
            </p>
          </DialogTitle>
          <GridContainer>
            {optionsList.map((options) => (
              <GridItem xs={3} key={options.value}>
                <CheckBox
                  key={options.value}
                  checkBoxChange={this.handleCheckBoxChange}
                  value={options.value}
                  label={options.label}
                />
              </GridItem>
            ))}
          </GridContainer>
        </div>
      );
    } else if (selectedValue === "radio") {
      let selectedRadioValue = "";
      if (selectedOption.hasOwnProperty("value")) {
        selectedRadioValue = selectedOption.value;
      }
      htmlContent = (
        <div>
          <DialogTitle
            id="classic-modal-slide-title"
            disableTypography
            // className={classes.modalHeader}
            style={{
              backgroundColor: "#d8d8d8",
              borderBottom: "none",
              padding: "10px",
              marginBottom: "10px",
              // paddingLeft: "24px"
              // minHeight: "16.43px"
            }}
          >
            <p
              style={{
                color: "#d8d8d8",
                margin: "0",
                paddingLeft: "0px",
                // lineHeight: "1.42857143"
              }}
            >
              <GridContainer>
                <GridItem xs={3}>{showButton}</GridItem>
                <GridItem xs={9}>
                  <span style={{ color: "black" }}>
                    <strong>Filter:</strong> &nbsp;
                    {navLinks}
                  </span>
                </GridItem>
              </GridContainer>
            </p>
          </DialogTitle>
          <div
            style={{
              paddingLeft: "20px",
              paddingTop: "30px",
              paddingRight: "20px",
            }}
          >
            <RadioGroup
              name="radio_button"
              value={selectedRadioValue}
              onChange={this.handleRadioButtonChange}
            >
              {optionsList.map((options, key) => (
                <FormControlLabel
                  key={key}
                  value={options.value}
                  control={<Radio color="primary" />}
                  label={options.label}
                />
              ))}
            </RadioGroup>
          </div>
        </div>
      );
    } else if (selectedValue === "sliders") {
      htmlContent = (
        <div
          style={{
            paddingLeft: "20px",
            paddingTop: "30px",
            paddingRight: "20px",
          }}
        >
          <DialogTitle
            id="classic-modal-slide-title"
            disableTypography
            // className={classes.modalHeader}
            style={{
              backgroundColor: "#d8d8d8",
              borderBottom: "none",
              padding: "10px",
              marginBottom: "10px",
              // paddingLeft: "24px"
              // minHeight: "16.43px"
            }}
          >
            <p
              style={{
                color: "#d8d8d8",
                margin: "0",
                paddingLeft: "0px",
                // lineHeight: "1.42857143"
              }}
            >
              <GridContainer>
                <GridItem xs={3}>{showButton}</GridItem>
                <GridItem xs={9}>
                  <span style={{ color: "black" }}>
                    <strong>Filter:</strong> &nbsp;
                    {navLinks}
                  </span>
                </GridItem>
              </GridContainer>
            </p>
          </DialogTitle>
          <GridItem xs={12} sm={12} md={6}>
            <legend>Sliders</legend>
            <Nouislider
              start={[40]}
              connect={[true, false]}
              step={1}
              range={{ min: 0, max: 100 }}
            />
          </GridItem>
        </div>
      );
    } else if (
      selectedValue === "datePicker" ||
      selectedValue === "timePicker" ||
      selectedValue === "dateTimePicker"
    ) {
      htmlContent = (
        <div
          style={{
            paddingLeft: "20px",
            paddingTop: "30px",
            paddingRight: "20px",
          }}
        >
          <DialogTitle
            id="classic-modal-slide-title"
            disableTypography
            // className={classes.modalHeader}
            style={{
              backgroundColor: "#d8d8d8",
              borderBottom: "none",
              padding: "10px",
              marginBottom: "10px",
              // paddingLeft: "24px"
              // minHeight: "16.43px"
            }}
          >
            <p
              style={{
                color: "#d8d8d8",
                margin: "0",
                paddingLeft: "0px",
                // lineHeight: "1.42857143"
              }}
            >
              <GridContainer>
                <GridItem xs={4}>{showButton}</GridItem>
                <GridItem xs={8}>
                  <span style={{ color: "black" }}>
                    <strong>Filter:</strong> &nbsp;
                    {navLinks}
                  </span>
                </GridItem>
              </GridContainer>
            </p>
          </DialogTitle>
          <DatePicker
            startDate
            datePickerValue={this.handleDatePickerChange}
            selectedValue={selectedValue}
          />
        </div>
      );
    } else if (selectedValue === "customizedNumber") {
      let selectedNumberValue1 = "";
      let selectedNumberValue2 = "";
      if (
        tempKeyValuePairSelectedArr[tempKeyValuePairSelectedArr.length - 1]
          .label == "is equal to (==)" &&
        tempKeyValuePairSelectedArr[tempKeyValuePairSelectedArr.length - 1]
          .value === "="
      ) {
        if (selectedOption.hasOwnProperty("value")) {
          let selVal = String(selectedOption.value);
          if (selVal.indexOf("AND") !== -1) {
            selVal = selectedOption.value.split(" AND ");
            selectedNumberValue1 = selVal[0];
            selectedNumberValue2 = selVal[1];
          }
        }
        htmlContent = (
          <div>
            <DialogTitle
              id="classic-modal-slide-title"
              disableTypography
              style={{
                backgroundColor: "#d8d8d8",
                borderBottom: "none",
                padding: "10px",
                marginBottom: "10px",
              }}
            >
              <p
                style={{
                  color: "#d8d8d8",
                  margin: "0",
                  paddingLeft: "0px",
                }}
              >
                <GridContainer>
                  <GridItem xs={3}>{showButton}</GridItem>
                  <GridItem xs={9}>
                    <span style={{ color: "black" }}>
                      <strong>Filter:</strong> &nbsp;
                      {navLinks}
                    </span>
                  </GridItem>
                </GridContainer>
              </p>
            </DialogTitle>
            {/* {optionsList.map((options, key) => ( */}
            <React.Fragment>
              <center>
                <TextField
                  style={{
                    width: "50%",
                    marginTop: "2%",
                  }}
                  label="Offer Code"
                  // value={selectedNumberValue1}
                  // Commented the above line and added the below line in order to allow 0 to be deleted.
                  value={selectedNumberValue1 > "0" ? selectedNumberValue1 : ""}
                  onChange={(event) =>
                    this.rangenumberFieldMethodOfferCode(event, "offerCode")
                  }
                  type="number"
                  name="number_field_name"
                  inputProps={{
                    min: 0,
                    // max: options.label,
                    shrink: true,
                    // key: key,
                  }}
                  margin="normal"
                />
                <br />
                <TextField
                  style={{
                    width: "50%",
                    marginTop: "2%",
                  }}
                  label="Days From Expiration"
                  // value={selectedNumberValue2}
                  // Commented the above line and added the below line in order to allow 0 to be deleted.
                  value={selectedNumberValue2 > "0" ? selectedNumberValue2 : ""}
                  onChange={(event) =>
                    this.rangenumberFieldMethodOfferCode(
                      event,
                      "offerCodeDuration"
                    )
                  }
                  type="number"
                  name="number_field_name_range"
                  inputProps={{
                    min: 0,
                    // max: options.label,
                    shrink: true,
                    // key: key,
                  }}
                  margin="normal"
                />
              </center>
            </React.Fragment>
            {/* ))} */}
          </div>
        );
      }
    }
    if (showAddQueryButton) {
      showButton = (
        <BackButton
          icon="rightIcon"
          buttonName="Add"
          buttonLabel="Add"
          color="default"
          onAddButtonClick={this.onAddBackButtonClick}
        />
      );
      let content = (
        <div
          style={{
            paddingLeft: "20px",
            paddingTop: "30px",
            paddingRight: "20px",
            float: "right",
          }}
        >
          {showButton}
        </div>
      );
      return (
        <React.Fragment>
          {htmlContent}
          <span
            style={{ color: "red", marginLeft: "25%" }}
            className={this.state.error ? "block" : "hidden"}
          >
            Please select atleast one item
          </span>
          <span
            style={{ color: "red", marginLeft: "25%" }}
            className={this.state.locationsInputError ? "block" : "hidden"}
          >
            Please enter a valid input
          </span>
          <DialogActions
            style={{
              padding: "15px",
              textAlign: "right",
              paddingTop: "0",
              margin: "0",
            }}
          >
            {/* <span className={this.state.error ? "block" : "hidden"}>Error</span> */}
            <div className="popupbtngroup">
              {/* <a
                href="javascript:void(0)"
                className="btn popbtn"
                onClick={this.handleClose}
                key="close"
                aria-label="Close"
              >
                cancel
              </a>
              <a
                href="javascript:void(0)"
                className="btn popbtn"
                onClick={this.onAddBackButtonClick}
              >
                apply
              </a> */}
              <Button
                className="btn btncreate"
                // className="buttonRight"
                color="secondary"
                onClick={this.handleClose}
              >
                Cancel
              </Button>
              {/* // Commented the below code to add the submit button to use the locations copy paste feature. */}
              {/* <Button
                className="btn btncreate"
                // className="buttonRight"
                color="secondary"
                onClick={this.onAddBackButtonClick}
              >
                Apply
              </Button> */}

              {(this.state.localStorageClientId ===
                "712cc8e9-3a79-4900-b122-ec9812e0f0ca" ||
                this.state.localStorageClientId ===
                  "8c001fde-3728-48dc-9950-b8480ca9fbee" ||
                this.state.localStorageClientId ===
                  "3fe7e557-16f5-406c-bbc8-887fdec7ba8b" ||
                this.state.localStorageClientId ===
                  "dc0df8ce-c87e-4746-a00e-d2c9ee4d7534" ||
                this.state.localStorageClientId ===
                  "d1522630-2b9d-424e-a399-7ab3f7be274f" ||
                this.state.localStorageClientId ===
                  "7203dd51-f88b-4a4b-877c-92326d027915" ||
                this.state.localStorageClientId ===
                  "f1fbce23-e2ef-463c-bc97-6cde3c4cc4ac" ||
                this.state.localStorageClientId ===
                  "874b6c6a-83ff-480b-b615-1972538813ba" ||
                this.state.localStorageClientId === 
                  "b76e7818-deb1-4526-93a7-b398df3ea357" ||
                this.state.localStorageClientId ===
                  "e08840c5-c7d0-48c7-9c24-124b4cd80735" ||
                this.state.localStorageClientId === 
                  "68a4d4cc-1e57-4ccf-9dd1-a5ae890d0f2e" ||
                this.state.localStorageClientId ===
                  "0bc2a383-9ae0-4e9e-9652-0fb762ba6119" ||
                this.state.localStorageClientId ===
                  "7bf99619-30a3-47a3-b1de-d72b4f7f99a7" ||
                this.state.localStorageClientId === 
                  "a4dda78e-7678-4aaf-9bef-60a229085fc8" ||
                this.state.localStorageClientId === 
                  "cf6144d2-bb68-43b6-9876-dbf620b57c21" ||
                this.state.localStorageClientId === 
                  "83da098f-2fc7-4b98-8455-c08f9aceb4ed" ||
                this.state.localStorageClientId ===
                  "37f97bea-f005-4be1-8e41-286ad79a7f3a" ||
                this.state.localStorageClientId ===
                  "ec5a162e-5e87-4819-93bd-70bbf3b5f096" ||
                this.state.localStorageClientId ===
                  "24ab940a-50d2-41fd-b3b2-c67ca6cb0304" ) &&
              this.state.dropdownOrTextFieldToggle ? (
                <Button
                  className="btn btncreate"
                  // className="buttonRight"
                  color="secondary"
                  onClick={this.onSubmitButtonClick}
                >
                  Submit
                </Button>
              ) : (
                <Button
                  className="btn btncreate"
                  // className="buttonRight"
                  color="secondary"
                  onClick={this.onAddBackButtonClick}
                >
                  Apply
                </Button>
              )}
            </div>
          </DialogActions>
        </React.Fragment>
      );
    }
    return <React.Fragment>{htmlContent}</React.Fragment>;
  }
}

const mapStateToProps = (state) => ({
  cust_count: state.cust_count,
  cust_tillSqlSelectionArr: state.cust_tillSqlSelectionArr,
  cust_afterSqlSelectionArr: state.cust_afterSqlSelectionArr,
  cust_isModalOpen: state.cust_isModalOpen,
  cust_groupLeveltoggle: state.cust_groupLeveltoggle,
  cust_ruleLeveltoggle: state.cust_ruleLeveltoggle,
});

export default connect(mapStateToProps)(Selections);



// WEBPACK FOOTER //
// ./src/views/Audiences/CCustomQueryBuilder/Selections.jsx